export default "__VITE_ASSET__DVTwEzBr__"